export default class PaysTvaController {
	static $inject = ['$scope', '$state', '$stateParams', '$translate', 'TvaService'];

	constructor($scope, $state, $stateParams, $translate, TvaService) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.TvaService = TvaService;
	}

	async $onInit() {
		this.tvaListe = await this.TvaService.getTvaHeaders();
		this.tvas = [
			{ title: 'TOUS', venteKey: 'tvaVenteId', achatKey: 'tvaAchatId' },
			{ title: 'PRODUITS_LABEL', venteKey: 'tvaProduitVenteId', achatKey: 'tvaProduitAchatId' },
			{ title: 'PRESTATIONS_LABEL', venteKey: 'tvaPrestationVenteId', achatKey: 'tvaPrestationAchatId' },
			{ title: 'TRANSPORTS_LABEL', venteKey: 'tvaTransportVenteId', achatKey: 'tvaTransportAchatId' }
		];
	}
}
